import React from 'react';

// Field-label treatment shared by every tab on the /search page (Membership,
// SR Dashboard, Transactions) so their search forms look identical.
export const getSearchLabelStyle = (token: any, disabled = false): React.CSSProperties => ({
  fontSize: 12,
  fontWeight: 700,
  color: disabled ? token.colorTextDisabled : token.colorTextSecondary,
});
